<template>
  <div
    v-if="show && rail"
    class="customer-popup-overlay"
    @click.self="$emit('close')"
  >
    <div class="customer-popup-content">
      <!-- Header -->
      <div class="customer-popup-header">
        <div>
          <h3 class="customer-popup-title">{{ getBranch() }}</h3>
        </div>
        <button @click="$emit('close')" class="customer-popup-close" aria-label="Close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      
      <!-- Body -->
      <div class="customer-popup-body">
        <div class="customer-popup-section">
          <div class="port-stats-table">
            <table>
              <tbody>
                <tr>
                  <th>Division</th>
                  <td>{{ getDivision() }}</td>
                </tr>
                <tr>
                  <th>Subdivision</th>
                  <td>{{ getSubdivision() }}</td>
                </tr>
                <tr>
                  <th>Miles</th>
                  <td>{{ getMiles() }}</td>
                </tr>
                <tr>
                  <th>Tracks</th>
                  <td>{{ getTracks() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="customer-popup-footer">
        <button @click="$emit('close')" class="customer-popup-button">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RailPopup',
  props: {
    rail: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscKey);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKey);
  },
  methods: {
    getBranch() {
      if (!this.rail || !this.rail.properties) return 'Rail Line';
      return this.rail.properties.BRANCH || this.rail.properties.Branch || this.rail.properties.branch || 'Rail Line';
    },
    
    getDivision() {
      if (!this.rail || !this.rail.properties) return '-';
      return this.rail.properties.DIVISION || this.rail.properties.Division || this.rail.properties.division || '-';
    },
    
    getSubdivision() {
      if (!this.rail || !this.rail.properties) return '-';
      return this.rail.properties.SUBDIV || this.rail.properties.Subdivision || this.rail.properties.subdivision || '-';
    },
    
    getMiles() {
      if (!this.rail || !this.rail.properties) {
        console.log('[RailPopup] No rail or properties');
        return '-';
      }
      
      // Log all properties to see what's available
      console.log('[RailPopup] Rail properties:', this.rail.properties);
      
      // Try multiple property name variations (case-insensitive)
      const props = this.rail.properties;
      const miles = props.MilesGeo || props.Miles || props.miles || props.MILES ||
                    props.LENGTH || props.length || props.Length ||
                    props.LENGTHKM || props.lengthkm || props.LengthKM ||
                    props.SHAPE_LEN || props.Shape_Len || props.shape_len ||
                    props.SHAPE_LENGTH || props.Shape_Length || props.shape_length;
      
      if (!miles && miles !== 0) {
        console.log('[RailPopup] No miles value found');
        return '-';
      }
      
      const numMiles = parseFloat(miles);
      if (isNaN(numMiles)) {
        console.log('[RailPopup] Miles value is not a number:', miles);
        return miles;
      }
      
      console.log('[RailPopup] Miles value:', numMiles);
      return numMiles.toFixed(2);
    },
    
    getTracks() {
      if (!this.rail || !this.rail.properties) return '-';
      return this.rail.properties.TRACKS || this.rail.properties.Tracks || this.rail.properties.tracks || '-';
    },
    
    handleEscKey(event) {
      if (event.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    }
  }
};
</script>
